// @flow
import React from 'react';
// import { connect } from 'react-redux';
import {
  ErrorContainerDiv,
  ErrorGirlDiv,
  ErrorGirlImg,
  ContentParentDiv,
  TitleH1,
  SubTitleH3
} from './ErrorStyles';
import { ErrorButton } from '../ButtonStyles';

type Props = {
  errorGirl: string,
  title: string,
  subTitle: string
};

class ErrorPage extends React.Component<Props> {
  render() {
    return (
      <ErrorContainerDiv>
        <ErrorGirlDiv>
          <ErrorGirlImg src={this.props.errorGirl} alt="" />
        </ErrorGirlDiv>
        <ContentParentDiv>
          <TitleH1>{this.props.title}</TitleH1>
          <SubTitleH3>{this.props.subTitle}</SubTitleH3>
          <ErrorButton href="/">BACK TO HOME</ErrorButton>
        </ContentParentDiv>
      </ErrorContainerDiv>
    );
  }
}

// const mapStateToProps = state => ({
//   platformLogo: state.global.platformLogo
// });

// export default connect(mapStateToProps)(ErrorPage);
export default ErrorPage;
